import { MeetingsTypes, MeetingsAction, Meeting } from '../types';

export function requestGetListMeetings(coachId: string): MeetingsAction<{ coachId: string }> {
    return {
        type: MeetingsTypes.REQUEST_GET_LIST_MEETINGS,
        payload: { coachId },
    };
}

export function requestUpdateMeetingNote(
    meetingId: string,
    note: string,
): MeetingsAction<{ meetingId: string; note: string }> {
    return {
        type: MeetingsTypes.REQUEST_UPDATE_MEETING_NOTE,
        payload: { meetingId, note },
    };
}

export function updateMeetingNote(
    meetingId: string,
    note: string,
): MeetingsAction<{ meetingId: string; note: string }> {
    return {
        type: MeetingsTypes.UPDATE_MEETING_NOTE,
        payload: { meetingId, note },
    };
}

export function getListMeetings(meetings: Meeting[]): MeetingsAction<{ meetings: Meeting[] }> {
    return {
        type: MeetingsTypes.GET_LIST_MEETINGS,
        payload: { meetings },
    };
}

export function meetingsError(error: string) {
    return {
        type: MeetingsTypes.MEETINGS_ERROR,
        payload: { error },
    };
}

export function clearCoachError() {
    return {
        type: MeetingsTypes.CLEAR_MEETINGS_ERROR,
    };
}
